export default __webpack_public_path__ + "static/media/spd-pp-img.8b8ab80d.webp";